import createEntityBundle from '~/src/Lib/createEntityBundle'
import { WasteMethod as schema } from '~/src/Store/Schemas'

const name = 'wasteMethods'

export default createEntityBundle({
  name,
  apiConfig: {
    schema,
  },
})
